<template>
    <el-dialog
            title="远程门诊诊疗记录"
            :visible.sync="disVisible"
            width="55%"
            center>
        <el-divider style="margin:0 !important;"></el-divider>
        <el-form :model="infoForm" class="mt20" label-position="left" size="mini">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="病人姓名:" label-width="80px">
                        {{info.patName}}
                    </el-form-item>
                </el-col>
                <el-col :span="9">
                    <el-form-item label="性别:" label-width="60px">
                        {{info.patIdcard | getSexFromIdCardFilter}}
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="年龄:" label-width="60px">
                        {{info.patIdcard | getAgeFromIdCardFilter('岁')}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="就诊科室:" label-width="80px">
                        {{info.ksmc}}
                    </el-form-item>
                </el-col>
                <el-col :span="9">
                    <el-form-item label="身份证号:" label-width="80px">
                        {{info.patIdcard}}
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="电话:" label-width="60px">
                        {{info.patMobile}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="地址:" label-width="60px">
                        {{info.address || '暂无'}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <span class="title">病史部分:</span>
            </el-row>
            <el-row class="mt20">
                <el-form-item label="主诉:" label-width="80px">
                    <el-input v-model="infoForm.symptom" @input="changeLength(infoForm.symptom)" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容最多输入150个字..." :readonly="readonly" :maxlength="150"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="现病史:" label-width="80px">
                    <el-input v-model="infoForm.medicalHistory" @input="changeLength(infoForm.medicalHistory)" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容最多输入150个字..." :readonly="readonly" :maxlength="150"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="诊断:" label-width="80px">
                    <el-input v-model="infoForm.diagnosis" @input="changeLength(infoForm.diagnosis)" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容最多输入150个字..." :readonly="readonly" :maxlength="150"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="医生建议:" label-width="80px">
                    <el-input v-model="infoForm.suggestion" @input="changeLength(infoForm.suggestion)" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容最多输入150个字..." :readonly="readonly" :maxlength="150"></el-input>
                </el-form-item>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <div class="flex aic jcc">
                 <div class="close" @click="save" v-if="showBtn">保存</div>
                 <div class="close" @click="close" v-else>关闭</div>
            </div>
        </span>
    </el-dialog>
</template>

<script>
    import {getAgeFromIdCardFilter, getSexFromIdCardFilter} from "../../lib/filters";
    export default {
        name: "dis-diagnose-report",
        props:{
            info:{
                type:Object,
                default:()=>{
                    return {}
                }
            }
        },
        filters:{getAgeFromIdCardFilter, getSexFromIdCardFilter},
        data(){
            return {
                disVisible:false,
                infoForm:{},
                showBtn:false,
                readonly:false
            }
        },
        methods:{
            //1 表示是列表页
            showReport(fl=2){
                    this.disVisible = true;
                    this.infoForm = {
                        symptom:this.info.symptom || '',
                        medicalHistory:this.info.medicalHistory || '',
                        diagnosis:this.info.diagnosis || '',
                        suggestion:this.info.suggestion || '',
                        outpatientId:this.info.id,
                        ksmc:this.info.ksmc
                    }
                    this.showBtn = fl == '1' ? false : true
                    if(fl == '1') this.readonly = true;
            },
            close(){
                this.disVisible = false;
            },
            save(){
                this.disVisible = false;
                this.$emit('btn-click','修改诊疗记录',this.infoForm);
            },
            changeLength(val){
                if(val.length >= 500){
                    this.$message.error('字数超出限制。');
                }
            }
        }
    }
</script>

<style scoped>
    .title{
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #333333;
    }
    .close{
        width: 137px;
        height: 36px;
        background: #3692F9;
        border-radius: 4px;
        color: #ffffff;
        line-height:36px ;
        cursor:pointer;
    }
</style>